export default () => ({
  saved: false,
  wasRaised: false,
  beenUpdated: false,
  show: false,
  covenant: {
    covenant_id: null,
    active: true,
    plans: []
  },
  plans: [],
  nextStepButtonCompanyCovenants: [
    {
      icon: '',
      text: 'Novo Convênio Médico',
      name: 'professional.company.covenants.create',
      action: true
    },
    {
      icon: '',
      text: 'Corpo Clínico',
      name: 'professional.company.staffs.create',
      action: null
    },
    {
      icon: '',
      text: 'Honorários Médicos',
      name: 'professional.company.prices.create',
      action: null
    }
  ],
  nextStepButtonIsCompanyCovenants: [
    {
      icon: '',
      text: 'Novo Convênio Médico',
      name: 'professional.company.covenants.create',
      action: true
    },
    {
      icon: '',
      text: 'Honorários Médicos',
      name: 'professional.company.prices.create',
      action: null
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/create/resources/data.js